import BaseService from "./baseService";
import { reloadPlaylist } from "../redux/actions/index";

export class PlaylistService extends BaseService {
  constructor(base) {
    super(base);
    this.url = "/playlist";
    this.name = "Playlist";
  }
  MatchName(id) {
    let answer = this.searchId(this.store.getState().playlists, id);
    return answer ? answer.name : "-";
  }
  Match(id) {
    let answer = this.searchId(this.store.getState().playlists, id);
    return answer ? answer : {};
  }
  reload() {
    let self = this;
    return this.read().then(function(data) {
      if (!data.hasOwnProperty("error")) {
        self.store.dispatch(reloadPlaylist(data));
      }
    });
  }
}

export default PlaylistService;
